import { render, staticRenderFns } from "./CreateShiftType.vue?vue&type=template&id=763cfa9e&"
import script from "./CreateShiftType.vue?vue&type=script&lang=ts&"
export * from "./CreateShiftType.vue?vue&type=script&lang=ts&"
import style0 from "./CreateShiftType.vue?vue&type=style&index=0&id=763cfa9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports